<template>
    <div class="tw-animate-pulse tw-relative tw-flex tw-rounded-lg lg:tw-rounded-xl tw-overflow-hidden tw-relative tw-aspect-[2/3]">
        <div class="tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0 tw-bg-[#F2F2F2] dark:tw-bg-[#002039]"></div>
    </div>
</template>
